import React, {Component} from 'react'
import {Grid, withStyles} from '@material-ui/core'
import FullNameInput from '../FullNameInput'
import style from './style'
import {connect} from 'react-redux'
import {bindActionCreators} from "redux"
import {OfflinePaymentFormActions} from '../../actions'
import DocumentTypeSelector from "../DocumentTypeSelector"
import BankSelector from "../BankSelector"
import DocumentNumberInput from "../DocumentNumberInput"
import EmailInput from "../EmailInput"
import {PAGO_MIS_CUENTAS} from '../../../../shared/constants'


/**
 * Represents the form displayed in the Offline Payment Page.
 */
class OfflinePaymentForm extends Component {
    constructor(props) {
        super(props)

        let documentTypes = props.documentTypes

        documentTypes = JSON.parse(documentTypes.replace(/'/gi, '"'))

        this.documentTypes = {
            DNI: documentTypes["DNI"],
            LE: documentTypes["LE"],
            LC: documentTypes["LC"],
            IDENTIFICATION_CARD: documentTypes["Credencial de Elector"],
            PASSPORT: documentTypes["Pasaporte"]
        }

    }

    componentDidMount() {
        this.props.actions.fetchBanks(this.props.apikey, this.props.consumerUsername)
    }

    // EVENT HANDLERS

    /**
     * Changes the full name.
     *
     * @param event: The event raised when the changed takes place.
     * @param shouldValidate: Determines whether the full name value should be validated or not.
     */
    changeFullName = (event, shouldValidate = false) => {
        const fullName = event.target.value.toUpperCase()

        this.props.actions.changeFullName(fullName, shouldValidate)
    }

    /**
     * Drops the key press altogether if the pressed key is not allowed according to the selected full name.
     *
     * @param event: {Object} being the raised event.
     */
    preventWrongKeysForFullName = event => {
        const key = event.which,
            isLetter = key >= 65 && key <= 90,
            isControlKey = key === 8 || key === 9 || key === 32 || key === 165 || (key >= 35 && key <= 40)

        if (isLetter || isControlKey) {
            return
        }

        event.preventDefault()
    }

    /**
     * Changes the selected document type.
     *
     * @param event: The event raised when the changed takes place.
     */
    changeDocumentType = event => {
        const documentType = event.target.value
        const documentNumber = this.props.offlinePaymentForm.documentNumber

        this.props.actions.changeDocument(this.documentTypes, documentType, documentNumber, true)
    }

    /**
     * Changes the selected bank.
     *
     * @param event: The event raised when the changed takes place.
     */
    changeBank = event => {
        this.props.actions.changeBank(event.target.value)
    }


    /**
     * Handles the change event raised when modified the Document Number.
     *
     * @param event: The event raised when the modification happened.
     * @param shouldValidate: Determines whether the document type value should be validated or not.
     */
    changeDocumentNumber = (event, shouldValidate = false) => {
        const documentType = this.props.offlinePaymentForm.documentType
        const documentNumber = event.target.value.toUpperCase()

        this.props.actions.changeDocument(this.documentTypes, documentType, documentNumber, shouldValidate)
    }

    /**
     * Handles the change event raised when modified the Document Number.
     *
     * @param event: The event raised when the modification happened.
     * @param shouldValidate: Determines whether the document type value should be validated or not.
     */
    changeEmail = (event, shouldValidate = false) => {
        const email = event.target.value.toLowerCase()

        this.props.actions.changeEmail(email, shouldValidate)
    }


    /**
     * Drops the key press altogether if the pressed key is not allowed according to the selected Document type.
     * @param event: {Object} being the raised event.
     */
    preventWrongKeysForDocumentNumber = (event) => {
        const key = event.which,
            isShiftKeyPressed = event.shiftKey,
            isDigit = (key >= 96 && key <= 105) || (key >= 48 && key <= 57 && !isShiftKeyPressed),
            isControlKey = key === 8 || key === 9 || (key >= 35 && key <= 40)

        if (isDigit || isControlKey) {
            return
        }

        event.preventDefault()
    }


    /**
     * Renders the component.
     *
     * @returns The rendered JSX being the visual structure of the component.
     */
    render() {
        const {classes} = this.props

        let fullName = this.props.offlinePaymentForm.fullName || "",
            fullNameError = this.props.offlinePaymentForm.fullNameError || "",
            documentType = this.props.offlinePaymentForm.documentType || this.documentTypes.DNI,
            documentNumber = this.props.offlinePaymentForm.documentNumber || "",
            documentNumberError = this.props.offlinePaymentForm.documentNumberError || "",
            email = this.props.offlinePaymentForm.email || "",
            emailError = this.props.offlinePaymentForm.emailError || "",
            bank = this.props.offlinePaymentForm.bank || ""
        return (
            <div className={classes.formContainer}>
                <Grid container spacing={16}>
                    <Grid item xs={12}>
                        <FullNameInput fullName={fullName}
                                       fullNameError={fullNameError}
                                       changeFullName={this.changeFullName}
                                       preventWrongKeysForFullName={this.preventWrongKeysForFullName}
                                       classes={classes}
                                       tabIndex={1}/>
                    </Grid>

                    <Grid item xs={12} sm={5}>
                        <DocumentTypeSelector classes={classes}
                                              documentTypes={this.documentTypes}
                                              changeDocumentType={this.changeDocumentType}
                                              documentType={documentType}
                                              tabIndex={2}/>
                    </Grid>

                    <Grid item xs={12} sm={7}>
                        <DocumentNumberInput classes={classes}
                                             documentType={documentType}
                                             documentNumber={documentNumber}
                                             documentNumberError={documentNumberError}
                                             documentNumberMinLength={7}
                                             documentNumberMaxLength={8}
                                             changeDocumentNumber={this.changeDocumentNumber}
                                             preventWrongKeysForDocumentNumber={this.preventWrongKeysForDocumentNumber}
                                             tabIndex={3}/>
                    </Grid>

                    {GenerateEmailInput(this.props.paymentData, classes, email, emailError, this.changeEmail)}

                    {GenerateBankInput(this.props.paymentData, classes, bank, this.props.offlinePaymentForm.banks, this.changeBank)}
                </Grid>
            </div>
        )
    }
}


/**
 * @return {null}
 */
function GenerateEmailInput(paymentData, classes, email, emailError, changeEmail) {
    return paymentData.paymentMethod.indexOf(PAGO_MIS_CUENTAS) !== -1 ? (
        <Grid item xs={12}>
            <EmailInput classes={classes}
                        email={email}
                        emailError={emailError}
                        changeEmail={changeEmail}
                        tabIndex={4}/>
        </Grid>
    ) : null
}

/**
 * @return {null}
 */
function GenerateBankInput(paymentData, classes, bank, banks, changeBank) {
    return paymentData.paymentMethod.indexOf(PAGO_MIS_CUENTAS) !== -1 ? (
        <Grid item xs={12}>
            <BankSelector classes={classes}
                          bank={bank}
                          banks={banks}
                          changeBank={changeBank}
                          tabIndex={5}/>
        </Grid>
    ) : null
}

function mapStateToProps({offlinePaymentForm, forms}) {
    return {offlinePaymentForm, documentTypes: forms.formData.documentTypes, paymentData: forms.paymentData}
}

function mapDispatchToProps(dispatch) {
    return {actions: bindActionCreators(OfflinePaymentFormActions, dispatch)}
}

const ConnectedOfflinePaymentForm = connect(mapStateToProps, mapDispatchToProps)(OfflinePaymentForm)

export default withStyles(style)(ConnectedOfflinePaymentForm)
